import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Container, DialogContent, DialogTitle, Grid } from "@mui/material";
import { Add, ArrowDown2, ArrowUp2, Location } from "iconsax-react";
import { connect } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Thumbs, EffectFade } from "swiper";
import { formatPersianDate } from "../../../../utils/date";
import axios from "axios";
import BASE_URL from "../../../../constants/baseUrls";
import { LocaleContext } from "../../../../routing/LangRouter";
import { useTranslation } from "react-i18next";
import { Icon } from "@iconify/react";
import moment from "moment";
import weatherIconMap from "../../../../constants/weatherIconsMap";
import { ItineraryContext } from "../../../../constants/layouts/itinerary-layout";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
//import general components
import { BaseButton } from "../../../common/base-button/base-button";
import Description from "../description/description";
import Replace from "../replace/replace";
import FreeItem from "../free-item/free-item";

//import view components
import MobileItineraryItem from "./itinerary-item";

//import styles
import "./itinerary-list.scss";
import "./slider.scss";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "swiper/css/effect-fade";

//import images and icons
import MobileHeader from "../../../common/mobile-header/mobile-header";
import "leaflet/dist/leaflet.css";
import BaseDialog from "../../../common/base-dialog/base-dialog";
import { toast } from "react-toastify";

// Fix for default marker icon
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

const parseLocation = locationString => {
    if (!locationString) return null;
    const [lat, lng] = locationString.split(",").map(coord => parseFloat(coord));
    return { lat, lng };
};

const ItineraryMap = ({ locations, isOpen, onClose }) => {
    if (!isOpen) return null;

    // Filter out items without location and parse locations
    const validLocations = locations
        .filter(item => item.location)
        .map(item => ({
            ...item,
            parsedLocation: parseLocation(item.location),
        }))
        .filter(item => item.parsedLocation);

    if (validLocations.length === 0) {
        return (
            <div className="map-modal">
                <div className="map-container">
                    <button className="close-button" onClick={onClose}>
                        ×
                    </button>
                    <p>مکانی وجود ندارد</p>
                </div>
            </div>
        );
    }

    // Find center point (average of all locations)
    const center = validLocations.reduce(
        (acc, item) => {
            return {
                lat: acc.lat + item.parsedLocation.lat / validLocations.length,
                lng: acc.lng + item.parsedLocation.lng / validLocations.length,
            };
        },
        { lat: 0, lng: 0 },
    );

    return (
        <BaseDialog title="موقعیت یابی" open={isOpen} handleClose={onClose} maxWidth="xs" top="10%" icon="close">
            <DialogContent dividers={true}>
                <MapContainer center={[center.lat, center.lng]} zoom={13} style={{ height: "500px", width: "100%" }}>
                    <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    />
                    {validLocations.map((item, index) => (
                        <Marker key={index} position={[item.parsedLocation.lat, item.parsedLocation.lng]}>
                            <Popup>
                                {" "}
                                <div>
                                    <strong>{item.name1}</strong>
                                    <br />
                                    {item.name2}
                                    <br />
                                    {item.category}
                                    <br />
                                    <small>لوکیشن {index + 1}</small>
                                </div>
                            </Popup>
                        </Marker>
                    ))}
                </MapContainer>
            </DialogContent>
        </BaseDialog>
    );
};

function MobileItineraryList({ destinationCoordinates, data, allDates, handleConfirmItinrary }) {
    //general
    const navigate = useNavigate();
    const location = useLocation();
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [searchParams, setSearchParams] = useSearchParams();
    const { routes, setRoutes } = useContext(ItineraryContext);
    const accessToken = localStorage.getItem("accessToken");
    const width = window.innerWidth;
    const breakpoint = 900;
    const queryParams = new URLSearchParams(location.search);
    const [showMap, setShowMap] = useState(false);
    const [itineraryItem, setItineraryItem] = useState();

    const selectedFlight = JSON.parse(sessionStorage.getItem("selectedFlight"));
    const selectedIntFlight = JSON.parse(sessionStorage.getItem("selectedIntFlight"));
    const selectedRooms = JSON.parse(sessionStorage.getItem("selectedRooms"));
    const selectedIntRooms = JSON.parse(sessionStorage.getItem("selectedIntRooms"));

    useEffect(() => {
        searchParams.delete("action");
        setSearchParams(searchParams);
    }, []);

    //sessionStorage variables
    const itineraryInformation = JSON.parse(sessionStorage.getItem("itineraryInformation"));

    const cityId = itineraryInformation?.destination?.id ?? searchParams.get("cityId");

    //set itinerary energy to state
    const [itineraryList, setItineraryList] = useState([]);
    useEffect(() => {
        if (data?.length) {
            data.map(item =>
                item.map((itinerary, itineraryIndex) => {
                    if (itineraryIndex === item.length - 1) {
                        if (itinerary.remaining_energy < 50) {
                            item.push({ ...itinerary, energy: false });
                        }
                    }
                }),
            );
            setItineraryList(data);
        }
    }, [data]);

    //set time for itinerary
    const handleTimesDetails = action => {
        if (width < breakpoint) {
            const params = { action };
            setSearchParams(params);
        }
    };

    //weather
    const [weather, setWeather] = useState(null);
    const api = {
        base: "https://api.open-meteo.com/v1/forecast/",
    };
    const query = `latitude=${destinationCoordinates?.split(",")[0]}&longitude=${destinationCoordinates?.split(",")[1]}`;

    const getWeatherDaily = async () => {
        const response = await axios.get(
            `${api.base}?${query}&daily=weathercode,temperature_2m_max,temperature_2m_min&timezone=Asia%2FTehran&start_date=${itineraryInformation?.departureDate}&end_date=${itineraryInformation?.returnDate}`,
        );
        setWeather(response.data.daily);
    };

    const getWeatherHourly = async day => {
        setLoadingReplaceList(true);
        try {
            const response = await axios.get(
                `${api.base}?${query}&hourly=temperature_2m,weathercode&timezone=Asia/Tehran&start_date=${allDates[day - 1]}&end_date=${
                    allDates[day - 1]
                }`,
            );
            const temperatureList = response.data.hourly.temperature_2m.map(temp => {
                return temp ? temp : 12;
            });
            return temperatureList;
        } catch (error) {
            return [];
        }
    };

    useEffect(() => {
        if (destinationCoordinates) {
            getWeatherDaily();
        }
    }, [destinationCoordinates]);

    //handle description modal
    const [openDescription, setOpenDescription] = useState(false);
    const [description, setDescription] = useState();
    const [locationtInformation, setlocationtInformation] = useState();
    const handleDescriptionModal = async planInformation => {
        queryParams.set("action", "description-mobile");
        const newSearch = `?${queryParams.toString()}`;
        setSearchParams(newSearch);

        setDescription(planInformation);

        const response = await axios.get(`${BASE_URL}/location/info/`, {
            params: {
                pk: planInformation.ID,
            },
        });
        setlocationtInformation(response.data);
    };

    //handle replace modal
    const [openReplace, setOpenReplace] = useState(false);
    const [locationName, setLocationName] = useState("");
    const [locationImage, setLocationImage] = useState("");
    const handleReplaceModal = async planInformation => {
        queryParams.set("action", "replace-mobile");
        const newSearch = `?${queryParams.toString()}`;
        setSearchParams(newSearch);

        if (locale === "en") {
            setLocationName(planInformation.name1);
        } else {
            setLocationName(planInformation.name2);
        }
        setLocationImage(planInformation.image);
        // const temperaturesDay = await getWeatherHourly(planInformation.day_number);
        getReplaceList(planInformation.plan_id, planInformation.global_id);
    };

    //handle modal change
    useEffect(() => {
        if (searchParams.get("action") === "description-mobile") setOpenDescription(true);
        else setOpenDescription(false);

        if (searchParams.get("action") === "replace-mobile") setOpenReplace(true);
        else setOpenReplace(false);
    }, [searchParams]);

    //replace list request
    const [replaceList, setReplaceList] = useState([]);
    const [loadingReplaceList, setLoadingReplaceList] = useState(false);
    const getReplaceList = async (planId, globalId) => {
        try {
            setLoadingReplaceList(true);
            const params = JSON.stringify({
                // temperatures: temperaturesDay,
                edit_data: {
                    plan_id: planId,
                    removed_loc_global_id: globalId,
                },
            });
            const response = await axios.post(`${BASE_URL}/itinerary/plan_edit/${cityId}/`, params, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
            setReplaceList(response.data);
        } catch (error) {
            toast.error(t("errorMessage"));
            searchParams.delete("action");
            setSearchParams(searchParams);
        } finally {
            setLoadingReplaceList(false);
        }
    };

    //rating modal
    const handleRating = () => {
        if (!!accessToken) {
            setSearchParams({ action: "rating" });
        } else {
            setSearchParams({ action: "login" });
        }
    };

    const goToBack = () => {
        navigate(routes[routes.findIndex(route => route === location.pathname) - 1], { replace: true });
    };

    return (
        <Grid className="mobile-itinerary-list" container item xs={12} mb={12}>
            <MobileHeader
                title={t("itinerary")}
                skip={
                    <span className="mobile-itinerary-list__time" onClick={() => handleTimesDetails("set-time")}>
                        {t("setTime")}
                    </span>
                }
                justifyContent="center"
                isButton={true}
                handleClick={goToBack}
            />

            <>
                <Grid container item xs={12} order={2}>
                    <Swiper
                        autoHeight={true}
                        dir={locale === "en" ? "ltr" : "rtl"}
                        thumbs={{ swiper: thumbsSwiper }}
                        modules={[FreeMode, Navigation, Thumbs, EffectFade]}
                        className="mySwiper2"
                    >
                        {itineraryList.length
                            ? itineraryList?.map((oneDay, index) => {
                                  return (
                                      <SwiperSlide key={index}>
                                          {weather ? (
                                              <Grid
                                                  className={`mobile-itinerary-list__itinerary-header`}
                                                  container
                                                  item
                                                  xs={12}
                                                  justifyContent="space-between"
                                                  alignItems="center"
                                              >
                                                  <Grid container item xs={6} alignItems="center">
                                                      <Icon width="24" height="24" icon={weatherIconMap[weather?.weathercode?.[index]?.toString()]} />
                                                      <span>
                                                          &nbsp;{" "}
                                                          {locale === "en"
                                                              ? itineraryInformation.destination?.english_name
                                                              : itineraryInformation.destination.name}
                                                      </span>
                                                  </Grid>
                                                  <Grid
                                                      className="mobile-itinerary-list__weather"
                                                      container
                                                      item
                                                      xs={4}
                                                      justifyContent="space-between"
                                                  >
                                                      {weather.temperature_2m_min[index] !== null ? (
                                                          <span className="mobile-itinerary-list__weather-item mobile-itinerary-list__weather-item--down">
                                                              <ArrowDown2 size="12" color="var(--blue-color)" variant="Bold" />
                                                              {Math.round(weather.temperature_2m_min?.[index])}°
                                                          </span>
                                                      ) : (
                                                          "-"
                                                      )}
                                                      {weather.temperature_2m_max[index] !== null ? (
                                                          <span className="mobile-itinerary-list__weather-item mobile-itinerary-list__weather-item--up">
                                                              <ArrowUp2 size="12" color="var(--red-color)" variant="Bold" />
                                                              {Math.round(weather.temperature_2m_max?.[index])}°
                                                          </span>
                                                      ) : (
                                                          ""
                                                      )}
                                                  </Grid>
                                              </Grid>
                                          ) : (
                                              <Grid
                                                  className={`mobile-itinerary-list__itinerary-header`}
                                                  container
                                                  item
                                                  xs={12}
                                                  justifyContent="space-between"
                                                  alignItems="flex-start"
                                              >
                                                  <span>
                                                      {locale === "en"
                                                          ? itineraryInformation.destination?.english_name
                                                          : itineraryInformation?.destination?.name}
                                                  </span>
                                              </Grid>
                                          )}
                                          <Container maxWidth="xl">
                                              <Grid container item xs={12} mt={8} rowGap={2}>
                                                  <Grid container item xs={12} justifyContent="center" alignItems="center">
                                                      {/* Add Map Button */}
                                                      <BaseButton
                                                          text={t("showMap")}
                                                          color="secondary"
                                                          size="large"
                                                          radius="radius-10"
                                                          handleClick={() => {
                                                              setShowMap(true);
                                                              setItineraryItem(oneDay);
                                                          }}
                                                          rightIcon={<Location />}
                                                      />
                                                  </Grid>
                                                  {oneDay?.length ? (
                                                      oneDay.map((oneDayItem, index) => {
                                                          return (
                                                              <Grid
                                                                  key={oneDayItem?.ID}
                                                                  className="mobile-itinerary-list__day"
                                                                  container
                                                                  item
                                                                  xs={12}
                                                                  justifyContent="space-between"
                                                              >
                                                                  <Grid container item xs={1} justifyContent="center">
                                                                      <span className="mobile-itinerary-list__index-label">{index + 1}</span>
                                                                  </Grid>
                                                                  {oneDayItem.category === "free" && oneDayItem.ID === 0 ? (
                                                                      <FreeItem
                                                                          info={oneDayItem}
                                                                          handleReplaceModal={handleReplaceModal}
                                                                          index={index}
                                                                          length={oneDay.length}
                                                                      />
                                                                  ) : (
                                                                      <MobileItineraryItem
                                                                          info={oneDayItem}
                                                                          handleDescriptionModal={handleDescriptionModal}
                                                                          handleReplaceModal={handleReplaceModal}
                                                                          index={index}
                                                                          length={oneDay.length}
                                                                      />
                                                                  )}
                                                              </Grid>
                                                          );
                                                      })
                                                  ) : (
                                                      <Grid className="mobile-itinerary-list__no-plan" container item xs={12} justifyContent="center">
                                                          {t("itineraryMessage3")}
                                                      </Grid>
                                                  )}
                                              </Grid>
                                          </Container>
                                      </SwiperSlide>
                                  );
                              })
                            : ""}
                    </Swiper>
                </Grid>

                <Grid className="mobile-itinerary-list__all-date" container item xs={12} order={1}>
                    <Swiper
                        dir={locale === "en" ? "ltr" : "rtl"}
                        onSwiper={setThumbsSwiper}
                        spaceBetween={10}
                        slidesPerView={2.75}
                        freeMode={true}
                        watchSlidesProgress={true}
                        modules={[FreeMode, Navigation, Thumbs]}
                        className="mySwiper"
                    >
                        {data?.length
                            ? data?.map((_, index) => {
                                  return (
                                      <SwiperSlide key={index}>
                                          <span className="mobile-itinerary-list__date">
                                              {locale === "fa"
                                                  ? formatPersianDate(allDates[index], {
                                                        day: "numeric",
                                                        month: "long",
                                                        year: undefined,
                                                        weekday: "long",
                                                    })
                                                  : moment(allDates?.[index]).format("ddd D MMM")}
                                          </span>
                                      </SwiperSlide>
                                  );
                              })
                            : ""}
                    </Swiper>
                </Grid>

                {location.pathname === `/${locale}/itinerary/itinerary-page` && (
                    <Grid className="mobile-itinerary-list__confirm-itinerary" container item xs={12} justifyContent="space-between">
                        {!!selectedFlight  || !!selectedIntFlight || !!selectedRooms || !!selectedIntRooms ? (
                            <Grid container item xs={5.5} md={1.5} justifyContent="center" order={3}>
                                <BaseButton
                                    color="primary"
                                    text={t("nextLevel")}
                                    size="large"
                                    radius="radius-10"
                                    handleClick={handleConfirmItinrary}
                                />
                            </Grid>
                        ) : (
                            ""
                        )}

                        <Grid container item xs={5.5} md={1.5} justifyContent="center" order={3}>
                            <BaseButton text={t("rating")} color="secondary" size="large" radius="radius-10" handleClick={handleRating} />
                        </Grid>
                    </Grid>
                )}
            </>

            <ItineraryMap locations={itineraryItem || []} isOpen={showMap} onClose={() => setShowMap(false)} />
            <Description open={openDescription} setOpen={setOpenDescription} description={description} locationtInformation={locationtInformation} />
            <Replace
                open={openReplace}
                setOpen={setOpenReplace}
                list={replaceList}
                loadingReplaceList={loadingReplaceList}
                locationName={locationName}
                locationImage={locationImage}
            />
        </Grid>
    );
}

function mapStateToProps(state) {
    return {
        data: state.itineraryList,
    };
}

export default connect(mapStateToProps)(MobileItineraryList);
